<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        style="position: relative"
      >
        <el-form-item
          label="是否显示"
          prop="IsXs"
          :rules="[{ required: true, message: '请选择状态', trigger: 'blur' }]"
        >
          <el-switch
            v-model="state.model.IsXs"
            inline-prompt
            active-text="显示"
            inactive-text="不显示"
          />
        </el-form-item>
        <el-form-item label="显示平台" prop="Pt">
          <el-checkbox
            v-model="state.PtAll"
            label="全部"
            @change="onPtAllChange"
          />
          <el-checkbox
            v-model="state.PtWeb"
            label="网站"
            :disabled="state.PtAll"
            @change="onPtItemChange"
          />
          <el-checkbox
            v-model="state.PtWx"
            label="小程序"
            :disabled="state.PtAll"
            @change="onPtItemChange"
          />
        </el-form-item>
        <el-form-item
          label="标题"
          prop="Bt"
          :rules="[{ required: true, message: '请输入标题', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.Bt" />
        </el-form-item>
        <el-form-item label="摘要">
          <el-input
            type="textarea"
            v-model="state.model.Zy"
            :autosize="{ minRows: 4 }"
          />
        </el-form-item>
        <el-form-item label="正文">
          <gonggao_editor
            v-model:value="state.model.Zw"
            :key="'zw_editor_v' + editorVersion"
            placeholder="请输入公告正文内容，可插入图片..."
          ></gonggao_editor>
        </el-form-item>
        <el-form-item label="附件" prop="Fjs">
          <div>
            <el-upload
              action="#"
              :show-file-list="false"
              ref="uploadDom"
              :auto-upload="false"
              :on-change="onChangeFile"
              :on-exceed="onExceedFile"
            >
              <template #default>
                <el-button type="primary" :icon="UploadFilled">
                  选择文件
                </el-button>
              </template>
            </el-upload>
            <div
              v-for="(item, index) in state.model.Fjs"
              :key="item.Id || ('local_' + index)"
              class="gg_fj_row"
            >
              <el-icon class="gg_fj_icon"><Paperclip /></el-icon>
              <span class="gg_fj_name" :title="item.Mc">{{ item.Mc }}</span>
              <div class="gg_fj_actions">
                <el-button
                  v-if="item.Id && item.Dz"
                  type="primary"
                  link
                  size="small"
                  :icon="Download"
                  @click="onFileDownLoad(item)"
                >
                  下载
                </el-button>
                <el-button
                  type="danger"
                  link
                  size="small"
                  :icon="Delete"
                  @click="onFileDelete(item, index)"
                >
                  删除
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </ul>
    <ul class="detailBtn">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive, ref } from "vue";
import { UploadFilled, Delete, Download, Paperclip, Close } from "@element-plus/icons-vue";
import $http from "@/http/index";
import GongGaoEditor from "./GongGaoEditor.vue";
import {
  gonggao_detail,
  gonggao_add,
  gonggao_edit,
  fujian_add,
  fujian_delete,
} from "@/http/api";

export default {
  props: {
    id: Number,
  },
  components: {
    gonggao_editor: GongGaoEditor,
  },
  setup(props, { emit }) {
    const editorVersion = ref(0); // 用于强制重建富文本编辑器，确保图片正确显示
    const { proxy } = getCurrentInstance();
    const formDom = ref(null);
    const uploadDom = ref(null);
    const state = reactive({
      model: {
        IsXs: true,
        Fjs: [],
        Zw: "",
      },
      files: [],
      delFiles: [],
      PtAll: true,
      PtWeb: false,
      PtWx: false,
    });
    onMounted(() => {
      if (props.id) {
        gonggao_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data;
            if (!state.model.Zw) state.model.Zw = "";
            parsePt(res.data.Pt);
            // 数据加载完成后，重建富文本编辑器以正确显示内容和图片
            editorVersion.value++;
          }
        });
      }
    });

    // 解析平台字段到checkbox
    const parsePt = (pt) => {
      if (!pt || pt === "All") {
        state.PtAll = true;
        state.PtWeb = false;
        state.PtWx = false;
      } else {
        state.PtAll = false;
        state.PtWeb = pt.includes("Web");
        state.PtWx = pt.includes("Wx");
      }
    };

    // 构建平台上送值
    const buildPt = () => {
      if (state.PtAll) return "All";
      const arr = [];
      if (state.PtWeb) arr.push("Web");
      if (state.PtWx) arr.push("Wx");
      return arr.join(",");
    };

    // "全部"勾选时，取消网站和小程序
    const onPtAllChange = (val) => {
      if (val) {
        state.PtWeb = false;
        state.PtWx = false;
      }
    };

    // 网站/小程序勾选时，取消"全部"
    const onPtItemChange = () => {
      if (state.PtWeb || state.PtWx) {
        state.PtAll = false;
      }
    };

    //选择文件
    const onUploadChange = (file) => {
      state.files.push(file.raw);
    };

    const onChangeFile = (file) => {
      let formData = new FormData();
      formData.append("file", file.raw);
      fujian_add(formData).then((res) => {
        if (res.status == 200) state.model.Fjs.push(res.data);
      });
    };

    const onExceedFile = (files) => {
      files.forEach((file) => {
        let formData = new FormData();
        formData.append("file", file);
        fujian_add(formData).then((res) => {
          if (res.status == 200) state.model.Fjs.push(res.data);
        });
      });
    };

    //删除附件：先调后端删除接口，成功后再移除本地列表
    const onFileDelete = (item, index) => {
      const removeLocal = () => state.model.Fjs.splice(index, 1);
      // 新上传但还没生成 Id 的文件，直接从前端移除
      if (!item.Id) {
        removeLocal();
        return;
      }
      // 已有 Id 的附件，通过 $confirm_func 统一处理：
      // 签名：confirm_func(func, id, backFunc, message)
      proxy.$confirm_func(
        fujian_delete,
        item.Id,
        removeLocal,
        "确定要删除该附件吗？"
      );
    };

    //下载附件
    const onFileDownLoad = (item) => {
      if (!item || !item.Dz) return;
      $http
        .get(item.Dz, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.Mc || "附件");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          // 兜底：直接打开路径
          window.open(item.Dz, "_blank");
        });
    };

    //删除图片（保留，兼容旧的 upload 组件逻辑）
    const onHandleRemove = (file) => {
      uploadDom.value.handleRemove(file);
      state.files.splice(state.files.indexOf(file.raw), 1);
      if (file.url?.includes?.("file/gonggao")) state.delFiles.push(file.url);
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        state.model.Fjids = state.model.Fjs.map((m) => m.Id);
        state.model.Pt = buildPt();

        // let formData = new FormData();
        // //把接口需要的参数带进去
        // formData.append("IsXs", state.model.IsXs);
        // formData.append("Bt", state.model.Bt);
        // formData.append("Zy", state.model.Zy);
        // formData.append("Zw", editorDom.value?.state?.value);
        // formData.append("DelFj", state.delFiles.join(","));

        // state.files.forEach((file) => {
        //   formData.append(file.uid, file);
        // });

        if (props.id) {
          gonggao_edit(props.id, state.model).then((res) => {
            proxy.$post_response(res, emit);
          });
        } else {
          gonggao_add(state.model).then((res) => {
            proxy.$post_response(res, emit);
          });
        }
      });
    };

    return {
      state,
      formDom,
      onSubmit,
      props,
      uploadDom,
      onUploadChange,
      onHandleRemove,
      onChangeFile,
      onExceedFile,
      onPtAllChange,
      onPtItemChange,
      editorVersion,
      onFileDelete,
      onFileDownLoad,
      // icons
      UploadFilled,
      Delete,
      Download,
      Paperclip,
      Close,
    };
  },
};
</script>
<style scoped lang="less">
// 附件行样式
.gg_fj_row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  margin-top: 10px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  transition: all 0.2s;

  &:hover {
    background: #f0f5ff;
    border-color: #d9e6ff;
  }

  .gg_fj_icon {
    flex-shrink: 0;
    color: #409eff;
    font-size: 16px;
  }

  .gg_fj_name {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    color: #303133;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .gg_fj_actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
</style>
